export default "__VITE_ASSET__C9_$QNea__"